import CounterInput from '@/atoms/forms/Counter';
import CardThumb from '@/molecules/CardThumb';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import useAddToTradeList from 'context/Modal/views/TradeList/AddToTradeList/hook';
import { CardDetailsWithStats } from 'hooks/queries/cards/useCardsDetailsApi';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SIZE } from 'types/utils';

type Props = {
  closeModal: () => void;
  card: CardDetailsWithStats;
};

const AddToTradeList = ({ closeModal, card }: Props) => {
  const { handleSubmit, formMethods } = useAddToTradeList(card, closeModal);
  const { t } = useTranslation();

  return (
    <ModalClassicLayout closeModal={closeModal} onSubmit={handleSubmit} title={t('addToTradeList.title')}>
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit}>
          <div className="flex flex-col gap-2">
            <p className="md-bold-caps text-center">{card.name}</p>
            <div className="flex flex-col gap-4 mx-auto">
              <CardThumb
                alt=""
                imagePath={card.imagePath}
                inMyCollection={card.stats?.inMyCollection}
                inMySale={card.stats?.inMySale || 0}
                isExclusive={!!card.stats?.isExclusive}
                isSuspended={card.isSuspended}
                numberCopyAvailable={card.stats?.numberCopyAvailable}
                size={SIZE.LG}
              />
              <CounterInput max={card.stats?.numberCopyAvailable || 0} min={0} name="quantity" />
            </div>
          </div>
        </form>
      </FormProvider>
    </ModalClassicLayout>
  );
};

export default AddToTradeList;
